module.exports = __webpack_public_path__ + "img/lifesaver.4d4ac6e8.png";